import React from 'react'
import PropTypes from 'prop-types'
import Marquee from 'react-fast-marquee'
import cn from 'classnames'

import ItemCreator from '~components/ItemCreator'

import * as s from './CreatorsMarquee.module.scss'

const CreatorsMarquee = (props) => {
  const { creators, className } = props

  return (
    <div className={cn(s.marquee, className)}>
      <Marquee gradient={false} speed={50} direction="left">
        {creators.map(({ id, avatar, avatarImg, name, subscribersCount }) => (
          <ItemCreator
            key={id}
            node={avatar}
            avatarImg={avatarImg}
            title={name}
            subs={`${subscribersCount} Subs`}
            className="mx-3"
          />
        ))}
      </Marquee>
    </div>
  )
}

CreatorsMarquee.defaultProps = {
  creators: undefined,
  className: undefined,
}

CreatorsMarquee.propTypes = {
  creators: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      avatar: PropTypes.object,
      name: PropTypes.string,
      subscribersCount: PropTypes.string,
    }).isRequired
  ),
  className: PropTypes.string,
}

export default CreatorsMarquee
